import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getEquipmentPledges(companyId, equipmentId) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_PLEDGES,dtConfig[ModulesMap.EQUIPMENT_PLEDGES].getEquipmentPledges, {
		urlParams: {
			companyId,
			equipmentId,
		},
	})
}
function getEquipmentPledge(companyId, equipmentId, pledgeId) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_PLEDGES,dtConfig[ModulesMap.EQUIPMENT_PLEDGES].getEquipmentPledge, {
		urlParams: {
			companyId,
			equipmentId,
            pledgeId,
		},
	})
}

function createEquipmentPledge(companyId, equipmentId, data) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_PLEDGES,dtConfig[ModulesMap.EQUIPMENT_PLEDGES].createEquipmentPledge, {
		urlParams: {
			companyId,
            equipmentId,
		},
		...data,
	})
}

function patchEquipmentPledge(companyId, equipmentId, pledgeId, data) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_PLEDGES,dtConfig[ModulesMap.EQUIPMENT_PLEDGES].patchEquipmentPledge, {
		urlParams: {
			companyId,
			equipmentId,
            pledgeId,
		},
		...data,
	})
}

function putEquipmentPledge(companyId, equipmentId, pledgeId, data) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_PLEDGES,dtConfig[ModulesMap.EQUIPMENT_PLEDGES].putEquipmentPledge, {
		urlParams: {
			companyId,
			equipmentId,
            pledgeId,
		},
		...data,
	})
}

function deleteEquipmentPledge(companyId, equipmentId, pledgeId) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_PLEDGES,dtConfig[ModulesMap.EQUIPMENT_PLEDGES].deleteEquipmentPledge, {
		urlParams: {
			companyId,
			equipmentId,
            pledgeId,
		},
	})
}

export default {
    getEquipmentPledges,
    getEquipmentPledge,
    createEquipmentPledge,
    patchEquipmentPledge,
    putEquipmentPledge,
    deleteEquipmentPledge,
}
